import ContainerWithImage from './ContainerWithImage';

export default ContainerWithImage;
